export const TABSKEY = {
    line: 'line',
    station: 'station'
};

export const STATIONCOLUMN = [
    {
        title: '站点编码',
        dataIndex: 'stationCode',
        minWidth: 240
    },
    {
        title: '站点ID',
        dataIndex: 'stationId',
        minWidth: 240
    },
    {
        title: '站点名称',
        dataIndex: 'stationName',
        minWidth: 240
    },
    {
        title: '位置信息',
        dataIndex: 'stationLoc',
        scopedSlots: { customRender: 'stationLoc' },
        minWidth: 260
    },
    {
        title: '站点地址',
        dataIndex: 'stationAddress',
        scopedSlots: { customRender: 'stationAddress' },
        minWidth: 200
    },
    // {
    //   title: "city_name_real",
    //   dataIndex: "cityNameReal",
    //   width: 140,
    // },
    {
        title: '操作',
        dataIndex: 'active',
        scopedSlots: { customRender: 'action' },
        width: 180,
        fixed: 'right'
    }
];

export const LINECOLUMN = [
    {
        title: '路线',
        children: [
            {
                title: '起始地区域',
                dataIndex: 'fromArea',
                key: 'fromArea',
                width: 100
            },
            {
                title: '起始地省份',
                dataIndex: 'fromProvince',
                key: 'fromProvince',
                width: 100
            },
            {
                title: '起始地城市',
                dataIndex: 'fromCity',
                key: 'fromCity',
                width: 100
            },
            {
                title: '目的地城市',
                dataIndex: 'desCity',
                key: 'desCity',
                width: 100
            }
        ]
    },
    {
        title: '温度',
        dataIndex: 'temperature',
        key: 'temperature',
        width: 100
    },
    {
        title: '最低时效要求',
        dataIndex: 'lowestDuration',
        key: 'lowestDuration',
        width: 120
    },
    {
        title: '报价时效',
        dataIndex: 'quoteDuration',
        key: 'quoteDuration',
        width: 100
    },
    {
        title: '零担-人民币/m³（不含税）',
        children: [
            {
                title: '最低收费',
                dataIndex: 'ltlQuote',
                key: 'ltlLowestPrice',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLowestPrice || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤3m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte3',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte3 || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤6m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte6',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte6 || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤15m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte15',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte15 || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤25m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte25',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte25 || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤50m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte50',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte50 || '-';
                    }
                },
                width: 80
            },
            {
                title: '≤90m³',
                dataIndex: 'ltlQuote',
                key: 'ltlLte90',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlLte90 || '-';
                    }
                },
                width: 80
            },
            {
                title: '>90m³',
                dataIndex: 'ltlQuote',
                key: 'ltlGt90',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ltlGt90 || '-';
                    }
                },
                width: 80
            }
        ]
    },
    {
        title: '整车-人民币/车（不含税）',
        children: [
            {
                title: '4.2m',
                dataIndex: 'ftlQuote',
                key: 'ftl42',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl42 || '-';
                    }
                },
                width: 80
            },
            {
                title: '5.2m',
                dataIndex: 'ftlQuote',
                key: 'ftl52',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl52 || '-';
                    }
                },
                width: 80
            },
            {
                title: '6.2m',
                dataIndex: 'ftlQuote',
                key: 'ftl62',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl62 || '-';
                    }
                },
                width: 80
            },
            {
                title: '7.6m',
                dataIndex: 'ftlQuote',
                key: 'ftl76',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl76 || '-';
                    }
                },
                width: 80
            },
            {
                title: '9.6m',
                dataIndex: 'ftlQuote',
                key: 'ftl96',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl96 || '-';
                    }
                },
                width: 80
            },
            {
                title: '13.5m',
                dataIndex: 'ftlQuote',
                key: 'ftl135',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl135 || '-';
                    }
                },
                width: 80
            },
            {
                title: '15m',
                dataIndex: 'ftlQuote',
                key: 'ftl150',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl150 || '-';
                    }
                },
                width: 80
            },
            {
                title: '16.5m',
                dataIndex: 'ftlQuote',
                key: 'ftl165',
                customRender: (text) => {
                    if (text) {
                        const data = JSON.parse(text);
                        return data.ftl165 || '-';
                    }
                },
                width: 80
            }
        ]
    },
    {
        title: '元/点（≥2）（不含税）',
        children: [
            {
                title: '同城多点提送货费',
                dataIndex: 'cityMultiDeliveryFee',
                key: 'cityMultiDeliveryFee',
                width: 140
            },
            {
                title: '异地多点提送货费',
                dataIndex: 'multiCityMultiDeliveryFee',
                key: 'multiCityMultiDeliveryFee',
                width: 140
            }
        ]
    },

    {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        customRender: (text) => text || '-',
        width: 160
    }
    // {
    //   title: "始发仓城市",
    //   dataIndex: "startCity",
    //   minWidth: 180,
    // },
    // {
    //   title: "始发仓",
    //   dataIndex: "startWarehouse",
    //   scopedSlots: { customRender: "startWarehouse" },
    //   minWidth: 200,
    // },
    // {
    //   title: "目的仓城市",
    //   dataIndex: "endCity",
    //   minWidth: 180,
    // },
    // {
    //   title: "目的仓",
    //   dataIndex: "endWarehouse",
    //   scopedSlots: { customRender: "endWarehouse" },
    //   minWidth:200
    // },
    // {
    //   title: "车型",
    //   dataIndex: "truckType",
    //   minWidth: 120,
    // },
    // {
    //   title: "价格(元)",
    //   dataIndex: "quotedPrice",
    //   minWidth: 120,
    // },
    // {
    //   title: "时效",
    //   dataIndex: "aging",
    //   minWidth: 120,
    // },
    // {
    //   title: "审批状态",
    //   dataIndex: "approvalStatus",
    //   scopedSlots: { customRender: "approvalStatus" },
    //   minWidth: 120,
    // },
    // {
    //   title: "满载率",
    //   dataIndex: "loadF",
    //   scopedSlots: { customRender: "loadF" },
    //   minWidth: 120,
    // },
    // {
    //   title: "区域",
    //   dataIndex: "area",
    //   minWidth: 120,
    // },
    // {
    //   title:'操作',
    //   dataIndex: "active",
    //   scopedSlots: { customRender: "action" },
    //   width:180,
    //   fixed:'right'
    // }
];
export const LINELOOPCOLUMN = [
    {
        title: '线路名称',
        dataIndex: 'route',
        minWidth: 180
    },
    {
        title: '始发仓城市',
        dataIndex: 'depCity',
        minWidth: 180
    },
    {
        title: 'supplier集合',
        dataIndex: 'supplier',
        scopedSlots: { customRender: 'supplier' },
        minWidth: 200
    },
    {
        title: '目的仓城市',
        dataIndex: 'desCity',
        minWidth: 180
    },
    {
        title: 'depot集合',
        dataIndex: 'depot',
        scopedSlots: { customRender: 'depot' },
        minWidth: 200
    },
    {
        title: '车型',
        dataIndex: 'truckType',
        minWidth: 120
    },
    {
        title: '价格(元)',
        dataIndex: 'price',
        minWidth: 120
    },
    {
        title: '时效',
        dataIndex: 'duration',
        minWidth: 120
    },
    {
        title: '审批状态',
        dataIndex: 'isApprove',
        scopedSlots: { customRender: 'isApprove' },
        minWidth: 120
    },
    {
        title: '满载率',
        dataIndex: 'loadFactorGoal',
        customRender: (text) => {
            if (text) {
                return text + '%';
            }
        },
        // scopedSlots: { customRender: 'loadFactorGoal' },
        minWidth: 120
    },
    {
        title: '区域',
        dataIndex: 'area',
        minWidth: 120
    }
    // {
    //     title: '操作',
    //     dataIndex: 'active',
    //     scopedSlots: { customRender: 'action' },
    //     width: 180,
    //     fixed: 'right'
    // }
];

export const CARTYPE = [
    {
        id: '1',
        name: '直接运输'
    },
    {
        id: '2',
        name: '循环提送货'
    }
];
export const CARTYPELIST = [
    {
        id: '4.2米',
        name: '4.2米'
    },
    {
        id: '5.2米',
        name: '5.2米'
    },
    {
        id: '6.2米',
        name: '6.2米'
    },
    {
        id: '7.6米',
        name: '7.6米'
    },
    {
        id: '9.6米',
        name: '9.6米'
    },
    {
        id: '12.5米',
        name: '12.5米'
    },
    {
        id: '13.5米',
        name: '13.5米'
    },
    {
        id: '15米',
        name: '15米'
    },
    {
        id: '16.5米',
        name: '16.5米'
    }
];

export const APPROVAL = {
    APPROVED: 'APPROVED',
    NO_APPROVAL: 'NO_APPROVAL'
};

export const APPROVAL_TYPE = {
    APPROVED: '已审核',
    NO_APPROVAL: '未审核'
};
